import { useParams } from 'react-router-dom';
import PlayerSessionProvider from '@/providers/PlayerSessionControlProvider';

interface PlayerSessionWrapperProps {
  children: React.ReactNode;
}

export default function PlayerSessionWrapper({ children }: PlayerSessionWrapperProps) {
  const { id } = useParams();

  if (!id) {
    return <div>Loading...</div>;
  }

  return <PlayerSessionProvider sessionID={id}>{children}</PlayerSessionProvider>;
}
